$(document).ready(function () {
	$( '.preloader' ).fadeOut(1000);
	/*- - - - - - - - - main slider - - - - - - - - - */
	$(".slider__wrapper").slick({
		infinite: true,
		slidesToShow: 1,
		dots: true,
		dotsClass: 'slider__dots',
		nextArrow: ' <button type="button" class="slick-next slick__arrows"><i class="icon-i-carousel-arrow"></i></button>',
		prevArrow: ' <button type="button" class="slick-prev slick__arrows"><i class="icon-i-carousel-arrow"></i></button>',
		appendArrows: $('.slider__arrows_box_wrapper'),
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnFocus: false,
		pauseOnHover: false,
		pauseOnDotsHover: false,
		responsive: [
			{
			breakpoint: 480,
			settings: {
				arrows: false,
				dots: false,
			}
		}]

	});

	$(".product-carousel").slick({
		infinite: true,
		slidesToShow: 5,
		dots: true,
		nextArrow: ' <span class="carousel-next"><i class="icon-i-carousel-arrow"></i></span>',
		prevArrow: ' <span class="carousel-prev"><i class="icon-i-carousel-arrow"></i></span>',
		autoplay: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					arrows: false,
					dots: false,
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					arrows: false,
					dots: false,
				}
			}
		]
	});

	$('.tour-article__gallery').slick({
		slidesToShow: 	1,
		slidesToScroll: 1,
		arrows: 		false,
		autoplay:		true,
		autoplaySpeed: 	3000
	});

	
	// $('.tour-article__carousel').slick({
	// 	slidesToShow: 	4,
	// 	slidesToScroll: 1,
	// 	asNavFor:		'.tour-article__gallery',
	// 	dots: 			false,
	// 	arrows: 		false,
	// 	centerMode: 	false,
	// 	focusOnSelect: 	true
	// });
	/* - - - - - - - - match height - - - - - - - - */
	$('.main__tour_item_title').matchHeight({
		byRow: true,
		property: 'height',
		target: null,
		remove: false
	});
	$('.product-layout__name').matchHeight({
		byRow: true,
		property: 'height',
		target: null,
		remove: false
	});
	$('.main__blog_item_title').matchHeight({
		byRow: true,
		property: 'height',
		target: null,
		remove: false
	});
	$('.main__blog_item_desc').matchHeight({
		byRow: true,
		property: 'height',
		target: null,
		remove: false
	});
	/* - - - - - - - - select - - - - - - - - */
	$('.form__filter_selec').selectric({
		maxHeight: 250,
		disableOnMobile: false,
		nativeOnMobile: false,
		arrowButtonMarkup: '<b class="form__filter_selec_button"><i class="icon icon-i-arrow-down"></i></i></b>',
	});

	/* - - - - - - - - iframe height - - - - - - - -*/

// let iframeHeight = () => {
//   if (window.matchMedia("(max-width: 576px)").matches) {
//     if($('*').is($('iframe').closest('p'))) {
//       let pWidth = $('iframe').siblings('img').css('width')
//       $('iframe').css('height', `${pWidth.slice(0, pWidth.length - 2) * 0.637 }px`)
//     }
//   } else {
//     if($('*').is($('iframe').closest('p'))) {
//       $('iframe').css('height', 'auto')
//     }
//   }
// }
// iframeHeight()
// $(window).on('resize', function() {
//   iframeHeight()
// })
});

$('body').on('click', '.header__search-toggle', function () {
	$(this).addClass('active').siblings('form').addClass('active');
	$('body').addClass('open-search');
});

$('body').on('click', '.header__nav-toggle', function (event) {
	$('.header__nav-toggle, .dropdown').toggleClass('active');
	$('body').toggleClass('unclickable');


});


$(document).on('click', function (e) {
	if (!$(e.target).closest('.header__search').length) {
		$('.header__search form, .header__search-toggle').removeClass('active');
		$('body').removeClass('open-search');

	}
	e.stopPropagation();
});
$('body').on('click', '.header__language-list a.active', function (e) {
	e.preventDefault();
});

$('body').on('click', '.tour-article__plan_item', function () {
	$( this ).addClass( 'active' ).siblings().removeClass( 'active' );
});
